import styles from "./linksSection.module.scss";

export function VenueHeader() {
  return (
    <section className={styles.venueHeaderContainer}>
      <div className={styles.tickerWrapper}>
        <img src="icons/ticker-2.svg" alt="" className={styles.ticker} />
      </div>
      <div className={styles.dateLockupWrapper}>
      <img
        src="icons/DateLockup.png"
        alt="Final 8 - March 6-8, 2026 - Calgary"
        className={styles.dateLockup}
        />
        </div>
    </section>
  );
  // return (
  //   <div className={styles.venueHeaderContainer}>
  //     <img
  //       src={"icons/basketball.svg"}
  //       alt="basketball icon"
  //       className={styles.venueIcon}
  //     />
  //     <section className={styles.eventName}>
  //       <p>men&apos;s basketball</p>
  //       <p>championship</p>
  //     </section>
  //     <p className={styles.ledFont}>2026</p>
  //     <p>UCALGARY</p>
  //     <p className={styles.ledFont}>MAR 6-8</p>
  //     <img
  //       src={"icons/mapleleaf.svg"}
  //       alt="maple leaf icon"
  //       className={styles.venueIcon}
  //     />
  //   </div>
  // );
}
